import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { CART_STORAGE_KEY, useCartStore } from '../store/cartStore';

/**
 * Tiene aggiornato il carrello salvato nel browser: lo riallinea al database
 * all'apertura del sito e a ogni ingresso nella pagina carrello, e lo tiene
 * uguale tra più schede aperte.
 */
export function useCartSync() {
  const onCart = useLocation().pathname === '/cart';

  useEffect(() => {
    // Uscendo dal carrello non serve, ma costa una sola richiesta.
    useCartStore
      .getState()
      .syncCart()
      .then((notices) => notices.forEach((notice) => toast.info(notice)));
  }, [onCart]);

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === CART_STORAGE_KEY) useCartStore.persist.rehydrate();
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);
}
